/* @flow */

import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import PagesMenu from './Pages/Menu';
import CatalogMenu from './Catalog/Menu';

const Navigation = () => (
  <div className="ui secondary pointing menu segment actions">
    <NavLink to="/pages" activeClassName="active" className="item link">
      Mes Pages
    </NavLink>
    <NavLink to="/archives" activeClassName="active" className="item link">
      Mes Archives
    </NavLink>
    <NavLink to="/deployments" activeClassName="active" className="item link">
      Mes Déploiements
    </NavLink>
    <Switch>
      <Route exact path="/pages">
        <PagesMenu />
      </Route>
      <Route path="/view">
        <CatalogMenu />
      </Route>
    </Switch>
  </div>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Navigation.js